// extracted by mini-css-extract-plugin
export default {"box":"-9-ucE6yQ3CmriEAn1q7lg==","inner":"FaB2Y8BJtcv+uXqm648b8w=="};